import { render, staticRenderFns } from "./PageLayoutForms.vue?vue&type=template&id=422436ac&scoped=true&"
import script from "./PageLayoutForms.vue?vue&type=script&lang=js&"
export * from "./PageLayoutForms.vue?vue&type=script&lang=js&"
import style0 from "./PageLayoutForms.vue?vue&type=style&index=0&id=422436ac&prod&lang=scss&"
import style1 from "./PageLayoutForms.vue?vue&type=style&index=1&id=422436ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422436ac",
  null
  
)

export default component.exports